import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { handleGetConvertValue } from "Util/converts";
import { getMeasurement } from "Util/getMeasurement";

import { ResourceIcons } from "../ResourceIcons";
import { Card, CardIcon, CardInfosWrapper, Details, PlainText, SubTitle } from "../styles";
import { SingleUseBadge } from "./styles";

interface ResourceStorageBoxCardProps {
  title?: string;
  text: string;
  capacityM3?: number | null;
  isSingleUse: boolean;
}

export const ResourceStorageBoxCard: React.FC<ResourceStorageBoxCardProps> = ({
  title,
  text,
  capacityM3,
  isSingleUse,
}) => {
  const { t: translate } = useTranslation();
  const measurement = getMeasurement();

  return (
    <Card sx={{ color: colors.gray600 }}>
      <CardIcon>
        <ResourceIcons name="container" size={24} />
      </CardIcon>

      <CardInfosWrapper>
        <Details>
          <PlainText>
            {title && <strong>{title}</strong>} <span>{text}</span>
          </PlainText>

          <SubTitle>
            {`${translate("capacity")} `}
            {handleGetConvertValue(
              capacityM3 || 0,
              measurement?.code,
              measurement?.decimalPlaces
            )}{" "}
            {measurement?.code}
          </SubTitle>
        </Details>

        {!!isSingleUse && <SingleUseBadge>{`${translate("singleUse")}`}</SingleUseBadge>}
      </CardInfosWrapper>
    </Card>
  );
};
